module.exports = __webpack_public_path__ + "assets/img/cz.9c5898c6.svg";